export class EnsureLoadedOnce {
  constructor(target: any) {
    this.ensureLoadedOnce(target);
  }

  private ensureLoadedOnce(target: any): void {
    if (target) {
      throw new Error(
        `${target.constructor.name} has already been loaded. Import this in the main.ts only.`,
      );
    }
  }
}
